import React from "react";
import { motion } from "framer-motion";
import { IoIosArrowBack } from "react-icons/io";
import { useNavigate } from "react-router-dom";
import styles from "./BackButton.module.scss";

const BackButton = ({ title, renderToolbar }) => {
  const navigate = useNavigate();
  return (
    <motion.div
      className={styles.headerBar}
      initial={{ opacity: 0, y: -10 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.4, ease: "easeOut" }}
    >
      <div className={styles.left}>
        <div className={styles.backBtn} onClick={() => navigate(-1)}>
          <IoIosArrowBack />
        </div>
        <h1 className={styles.title}>{title}</h1>
      </div>
      {renderToolbar && <div className={styles.toolbar}>{renderToolbar}</div>}
    </motion.div>
  );
};

export default BackButton;
